import { Injectable } from '@angular/core';
import { MenuAnchor } from '@shared/models';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeroMenuService {
  private readonly menu$: ReplaySubject<MenuAnchor[]>;

  constructor() {
    this.menu$ = new ReplaySubject<MenuAnchor[]>(1);
    this.menu$.next([]);
  }

  setMenu(menu: MenuAnchor[]): void {
    this.menu$.next(menu);
  }

  getMenu$(): ReplaySubject<MenuAnchor[]> {
    return this.menu$;
  }
}
